import { Alert, Button, Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isLoading: boolean;
  isLoadError: boolean;
  isRetrying: boolean;
  canOpenIntegrations: boolean;
  onRetry: () => void;
  onOpenIntegrations: () => void;
};

/**
 * Содержимое страницы настройки, пока интеграция с анонимизатором не готова: проверка,
 * её отказ или пустое состояние. Ссылка на список интеграций — только тому, кому он открыт.
 */
export const AnonymizerIntegrationGate: FC<Props> = ({
  isLoading,
  isLoadError,
  isRetrying,
  canOpenIntegrations,
  onRetry,
  onOpenIntegrations,
}) => {
  const { t } = useTranslation(['anonymizerConfig', 'common']);

  if (isLoading) {
    return <Skeleton className="h-full" />;
  }

  // Отказ проверки — не то же, что неготовая интеграция: настраивать её незачем, нужно повторить запрос
  if (isLoadError) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
        <Alert
          type="error"
          className="max-w-xl text-left"
          title={t('integrationGate.loadErrorTitle')}
          description={t('integrationGate.loadErrorDescription')}
        />
        <Button variant="secondary" isLoading={isRetrying} onClick={onRetry}>
          {t('common:retry')}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
      <Alert
        type="info"
        className="max-w-xl text-left"
        title={t('integrationGate.title')}
        description={t(canOpenIntegrations ? 'integrationGate.description' : 'integrationGate.adminDescription')}
      />
      {canOpenIntegrations && (
        <Button variant="secondary" onClick={onOpenIntegrations}>
          {t('integrationGate.openIntegrations')}
        </Button>
      )}
    </div>
  );
};
